// Историята на разделянията (1:1 с `SplitHistoryOut` в
// app/features/bills/schemas.py).
//
// Всички `Decimal` полета на BE-то идват като JSON НИЗ — описани са като
// низове и се парсват явно с `parseDecimal` преди аритметика.
// `item_names` е `{езиков код: име}` и се пълни от BE-то за всеки продукт и
// всяка добавка: това е името, което екранът показва, а не търсене в менюто.

import { api } from "./client";

export interface BillSplitModifier {
  id: number;
  /** Числов id на модификатор ИЛИ свободен текст на коментар. */
  modifier_id: string;
  created_at: string;
}

export interface BillSplitAddition {
  id: number;
  addition_item_id: number;
  station_id: number;
  item_names: Record<string, string>;
  quantity: string;
  price: string;
  percent: string;
  total_sum: string;
}

export interface BillSplitItem {
  id: number;
  item_id: number;
  station_id: number;
  item_names: Record<string, string>;
  quantity: string;
  price: string;
  percent: string;
  total_sum: string;
  status: string;
  status_name: string;
  modifiers: BillSplitModifier[];
  additions: BillSplitAddition[];
}

export interface BillSplit {
  id: number;
  split_date: string;
  waiter_id: number;
  waiter_name: string | null;
  from_bill_id: number;
  from_bill_name: string;
  to_bill_id: number;
  to_bill_name: string;
  comment: string | null;
  total_amount: string;
  items: BillSplitItem[];
}

export interface BillSplitsFilters {
  from_bill_id?: number;
  to_bill_id?: number;
  waiter_id?: number;
  start_date?: string;
  end_date?: string;
  /** Филтърът „смяна" (`lib/reportShift.ts`); без него — всички смени. */
  shift?: number;
}

export const getBillsSplits = async (
  filters?: BillSplitsFilters,
): Promise<BillSplit[]> => {
  const params = new URLSearchParams();

  if (filters?.from_bill_id) {
    params.append("from_bill_id", filters.from_bill_id.toString());
  }
  if (filters?.to_bill_id) {
    params.append("to_bill_id", filters.to_bill_id.toString());
  }
  if (filters?.waiter_id) {
    params.append("waiter_id", filters.waiter_id.toString());
  }
  if (filters?.start_date) {
    params.append("start_date", filters.start_date);
  }
  if (filters?.end_date) {
    params.append("end_date", filters.end_date);
  }
  if (filters?.shift) {
    params.append("shift", String(filters.shift));
  }

  const queryString = params.toString();
  const url = queryString ? `/bills/splits?${queryString}` : "/bills/splits";

  const response = await api.get<BillSplit[]>(url);
  return response.data;
};
